import { gql } from '@apollo/client'

export const userDraftFindManyQuery = gql`
  query UserDraftFindMany($filter: FilterFindManyUserDraftInput) {
    userDraftFindMany(filter: $filter) {
      _id
      title
      captionText
      imageUrl
      userUpload
      socialProfiles
      imageId
      fullPath
      template
      challenge
      user
      postStatus
      coverPhotoOffset
      coverPhotoUrl
      instagramPublishType
      instagramReelAudioName
      tikTokPrivacyStatus
      tikTokCommentDisabled
      tikTokDuetDisabled
      tikTokStitchDisabled
      media {
        _id
        url
        preview
        type
        uploaded
        design
        ref
        dimensions {
          x
          y
        }
      }
      imageDimensions {
        x
        y
      }
      category
      postDate
      tags
      isLiked
      isUsed
      index
      lastModified
      createdAt
    }
  }
`
